module.exports = __webpack_public_path__ + "assets/img/command.1136cd05.svg";